(function(){
  function qs(selector, root){ return (root || document).querySelector(selector); }
  function qsa(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function bootContactAndInquiry(){
    var trigger = qs('.saratti-lb-inquiry');
    var overlay = qs('[data-saratti-v2-overlay]');
    var contactPanel = qs('[data-saratti-contact-panel]');
    var enquiryPanel = qs('[data-saratti-v2-panel]');
    var closeButtons = qsa('[data-saratti-v2-close]');
    var openFormButtons = qsa('[data-saratti-open-form]');
    var backButtons = qsa('[data-saratti-contact-back]');
    var tidioButtons = qsa('[data-saratti-tidio]');
    var form = document.getElementById('saratti-v2-enquiry-form');
    var formWrap = qs('[data-saratti-v2-form-wrap]');
    var success = qs('[data-saratti-v2-success]');
    var submit = qs('[data-saratti-v2-submit]');
    if(!trigger || !overlay || !contactPanel || !enquiryPanel) return;

    function bodyLock(lock){ document.body.style.overflow = lock ? 'hidden' : ''; }

    function closeAll(){
      overlay.classList.remove('is-open');
      contactPanel.classList.remove('is-open');
      enquiryPanel.classList.remove('is-open');
      contactPanel.setAttribute('aria-hidden','true');
      enquiryPanel.setAttribute('aria-hidden','true');
      bodyLock(false);
    }

    function openContact(event){
      if(event) event.preventDefault();
      enquiryPanel.classList.remove('is-open');
      enquiryPanel.setAttribute('aria-hidden','true');
      overlay.classList.add('is-open');
      contactPanel.classList.add('is-open');
      contactPanel.removeAttribute('aria-hidden');
      bodyLock(true);
    }

    function openForm(event){
      if(event) event.preventDefault();
      contactPanel.classList.remove('is-open');
      contactPanel.setAttribute('aria-hidden','true');
      overlay.classList.add('is-open');
      enquiryPanel.classList.add('is-open');
      enquiryPanel.removeAttribute('aria-hidden');
      bodyLock(true);
      if(success && success.style.display === 'flex'){
        success.style.display = 'none';
        if(formWrap) formWrap.style.display = 'block';
        if(form) form.reset();
        if(submit){ submit.textContent = 'Submit'; submit.disabled = false; }
      }
    }

    function openTidio(event){
      if(event) event.preventDefault();
      closeAll();
      function open(){
        if(window.tidioChatApi && typeof window.tidioChatApi.open === 'function'){
          window.tidioChatApi.open();
          return true;
        }
        return false;
      }
      if(open()) return;
      var opened = false;
      var ready = function(){
        if(opened) return;
        opened = open();
      };
      document.addEventListener('tidioChat-ready', ready, { once: true });
      window.setTimeout(ready, 700);
      window.setTimeout(ready, 1600);
    }

    if(trigger.getAttribute('data-saratti-contact-bound') !== 'true'){
      trigger.setAttribute('data-saratti-contact-bound','true');
      trigger.addEventListener('click', openContact);
    }

    overlay.onclick = closeAll;
    closeButtons.forEach(function(btn){
      if(btn.getAttribute('data-saratti-close-bound') === 'true') return;
      btn.setAttribute('data-saratti-close-bound','true');
      btn.addEventListener('click', closeAll);
    });
    openFormButtons.forEach(function(btn){
      if(btn.getAttribute('data-saratti-form-bound') === 'true') return;
      btn.setAttribute('data-saratti-form-bound','true');
      btn.addEventListener('click', openForm);
    });
    backButtons.forEach(function(btn){
      if(btn.getAttribute('data-saratti-back-bound') === 'true') return;
      btn.setAttribute('data-saratti-back-bound','true');
      btn.addEventListener('click', openContact);
    });
    tidioButtons.forEach(function(btn){
      if(btn.getAttribute('data-saratti-tidio-bound') === 'true') return;
      btn.setAttribute('data-saratti-tidio-bound','true');
      btn.addEventListener('click', openTidio);
    });
    document.addEventListener('keydown', function(event){
      if(event.key === 'Escape' && (contactPanel.classList.contains('is-open') || enquiryPanel.classList.contains('is-open'))) closeAll();
    });

    function validateField(id, errorId, test){
      var field = document.getElementById(id);
      var error = document.getElementById(errorId);
      if(!field || !error) return true;
      var bad = !test(field);
      error.style.display = bad ? 'block' : 'none';
      field.style.borderBottomColor = bad ? '#c00' : '#ccc';
      return !bad;
    }

    function validate(){
      var ok = true;
      ok = validateField('saratti-v2-title','saratti-v2-error-title',function(f){ return f.value !== ''; }) && ok;
      ok = validateField('saratti-v2-first','saratti-v2-error-first',function(f){ return f.value.trim() !== ''; }) && ok;
      ok = validateField('saratti-v2-last','saratti-v2-error-last',function(f){ return f.value.trim() !== ''; }) && ok;
      ok = validateField('saratti-v2-email','saratti-v2-error-email',function(f){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim()); }) && ok;
      ok = validateField('saratti-v2-message','saratti-v2-error-message',function(f){ return f.value.trim() !== ''; }) && ok;
      return ok;
    }

    function showSuccess(){
      if(formWrap) formWrap.style.display = 'none';
      if(success) success.style.display = 'flex';
      enquiryPanel.scrollTop = 0;
    }

    if(form && form.getAttribute('data-saratti-form-submit-bound') !== 'true'){
      form.setAttribute('data-saratti-form-submit-bound','true');
      form.addEventListener('submit', function(event){
        event.preventDefault();
        if(!validate()) return;
        if(submit){ submit.textContent = 'Sending...'; submit.disabled = true; }
        var action = form.getAttribute('action') || '/contact';
        var params = new URLSearchParams(new FormData(form)).toString();
        fetch(action, {
          method: 'POST',
          body: params,
          headers: {'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'}
        }).then(showSuccess).catch(showSuccess);
      });
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootContactAndInquiry);
  else bootContactAndInquiry();
  document.addEventListener('shopify:section:load', bootContactAndInquiry);
})();